import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { formatCurrency, parseValorMes, useModuloFiscalData } from './useModuloFiscalData';
import './moduloFiscal.css';

export default function ModuloFiscalContratosPage() {
  const { fiscalId } = useParams();
  const navigate = useNavigate();
  const { loading, error, fiscal, contratos, badges } = useModuloFiscalData(fiscalId);

  if (loading) {
    return (
      <div className="mf-page mf-page--embedded">
        <div className="mf-state">
          <CircularProgress sx={{ color: 'var(--ep-accent)' }} />
          <p>Carregando contratos…</p>
        </div>
      </div>
    );
  }

  if (error || !fiscal) {
    return (
      <div className="mf-page mf-page--embedded">
        <div className="mf-state">
          <p>{error || 'Fiscal não encontrado.'}</p>
          <button
            type="button"
            className="mf-page__back"
            onClick={() => navigate('/home', { state: { openFiscalMap: true } })}
          >
            Voltar ao mapa
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mf-page mf-page--embedded">
      <header className="mf-page__header">
        <div>
          <h1 className="mf-page__title">Contratos — {fiscal.nome}</h1>
          <p className="mf-page__meta">
            Setor: <strong>{fiscal.setor || '—'}</strong> · clique no contrato para ver a trilha e PDFs
          </p>
        </div>
      </header>

      <p className="mf-note">
        Consulta dos contratos do setor. Clique na linha para abrir o contrato primitivo, aditivos,
        vigências/valores e avaliação do fornecedor.
      </p>

      <div className="mf-table-wrap">
        {contratos.length === 0 ? (
          <div className="mf-empty">Nenhum contrato ativo neste setor.</div>
        ) : (
          <table className="mf-table">
            <thead>
              <tr>
                <th>Empresa</th>
                <th>Nº contrato</th>
                <th>Valor mensal</th>
                <th>Vigência</th>
                <th>Docs</th>
              </tr>
            </thead>
            <tbody>
              {contratos.map((c) => {
                const b = badges[c.numeroContrato] || {};
                return (
                  <tr
                    key={c.id || c.numeroContrato}
                    className="mf-row--clickable"
                    onClick={() =>
                      navigate(`/modulos/fiscal/${fiscalId}/contratos/${c.id}`)
                    }
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigate(`/modulos/fiscal/${fiscalId}/contratos/${c.id}`);
                      }
                    }}
                    tabIndex={0}
                    role="link"
                    aria-label={`Abrir contrato ${c.numeroContrato}`}
                  >
                    <td>{c.empresa || '—'}</td>
                    <td>{c.numeroContrato || '—'}</td>
                    <td>{formatCurrency(parseValorMes(c.valorMes))}</td>
                    <td>
                      {[c.vigenciaInicio, c.vigenciaFim].filter(Boolean).join(' → ') || '—'}
                    </td>
                    <td>
                      <div className="mf-badges">
                        <span
                          className={`mf-badge ${b.ad ? 'mf-badge--on' : 'mf-badge--off'}`}
                          title={b.ad ? 'Possui aditivo' : 'Sem aditivo'}
                        >
                          AD
                        </span>
                        <span
                          className={`mf-badge ${b.nf ? 'mf-badge--on' : 'mf-badge--off'}`}
                          title={b.nf ? 'Possui nota fiscal' : 'Sem NF'}
                        >
                          NF
                        </span>
                        <span
                          className={`mf-badge ${b.av ? 'mf-badge--on' : 'mf-badge--off'}`}
                          title={b.av ? 'Possui avaliação' : 'Sem avaliação'}
                        >
                          AV
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
